import { useState } from "react";
import { Mail, Wine, Calendar, Tag, Check } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const benefits = [
    { icon: Calendar, text: "Invitaciones a catas de vino" },
    { icon: Wine, text: "Nuevas referencias de nuestra bodega" },
    { icon: Tag, text: "Promociones exclusivas" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      const response = await axios.post(`${API}/newsletter/subscribe`, { email });
      if (response.data.success) {
        toast.success(response.data.message);
        setEmail("");
      }
    } catch (error) {
      if (error.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error("Error al suscribirse. Por favor, inténtalo de nuevo.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="newsletter-gradient section-padding">
      <div className="max-w-4xl mx-auto text-center">
        {/* Icon */}
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center border border-[#C5A059]">
          <Mail size={28} className="text-[#800020]" />
        </div>

        {/* Header */}
        <h2 className="font-heading text-3xl sm:text-4xl text-[#1A1A1A] mb-4">
          Únete a Nuestra Comunidad Gastronómica
        </h2>
        <p className="font-body text-[#1A1A1A]/70 mb-8 max-w-2xl mx-auto">
          Suscríbete y recibe antes que nadie las novedades de Abacería Como en Casa
        </p>

        {/* Benefits */}
        <div className="flex flex-wrap justify-center gap-6 mb-10">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="flex items-center gap-2"
              data-testid={`newsletter-benefit-${index}`}
            >
              <benefit.icon size={18} className="text-[#800020]" />
              <span className="font-body text-sm text-[#1A1A1A]/80">
                {benefit.text}
              </span>
            </div>
          ))}
        </div>

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Tu email"
            data-testid="newsletter-email"
            className="flex-1 px-6 py-4 bg-white border border-[#DCD7CC] font-body text-[#1A1A1A] placeholder:text-[#1A1A1A]/50 focus:outline-none focus:border-[#800020]"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit"
            className="btn-primary whitespace-nowrap"
          >
            {loading ? "Enviando..." : "Suscribirme"}
          </button>
        </form>

        {/* Trust badge */}
        <div className="mt-6 flex items-center justify-center gap-2 text-[#1A1A1A]/50">
          <Check size={14} />
          <span className="font-body text-xs">
            Sin spam. Solo contenido de calidad.
          </span>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
